import Axios from "axios";
import { SETTINGS } from "../properties/ApiProps";

export const OccupationRepository = {
  getOccupations: (name) => {
    return Axios({
      url: SETTINGS.API_URL + "occupation/filteredByName",
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
      params: {
        nameFilter: name,
      },
    });
  },
  getOccupationsPageable: (title, page, size) => {
    return Axios({
      url: SETTINGS.API_URL + "occupation/filteredByNamePageable",
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
      params: {
        title: title,
        page: page,
        size: size,
      },
    });
  },
  getOccupationById: (id) => {
    return Axios({
      url: SETTINGS.API_URL + `occupation/${id}`,
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
};
